<template>
  <router-view />
</template>

<style>
@import "@/style/scss/style.scss";
</style>
